import { Box, List, ListItem, Typography } from '@mui/material'
import React from 'react'
import FullWhiteLogo from '../../Assets/Images/FullWhiteLogo.png'
import { Link, useNavigate } from 'react-router-dom'
import RoundTextLogo from '../RoundedTextLogo'
import AutoRoundTextLogo from '../AutoRoundTextLogo'

function Footer() {
    const navigate = useNavigate()
    return (
        <Box bgcolor={'hsl(187, 100%, 12%)'}>
            <Box className='d-flex p-3  justify-content-between' alignItems={{ xs: 'start', md: 'center' }} flexDirection={{ xs: "column", md: 'row' }} >
                <Box className='d-flex flex-column' gap={5}>
                    <Box component={'img'} src={FullWhiteLogo} maxHeight={'30px'}></Box>
                    <Box className='d-flex flex-column' gap={1}>
                        <Link to={'/privacy-policy'} className='text-white'>PRIVACY POLICY</Link>
                        <Link to={'/development-practices'} className='text-white'>DEVELOPMENT PRACTICES</Link>
                    </Box>
                </Box>
                <Box>
                    <List className='fs-18 d-flex text-white' sx={{ flexDirection: { xs: "column", lg: "row" } }}>
                        <ListItem onClick={() => { navigate("/") }}>HOME</ListItem>
                        <ListItem onClick={() => { navigate("/about") }}>ABOUT</ListItem>
                        <ListItem onClick={() => { navigate("/clients") }} className='align-itmes-end'>CLIENTS</ListItem>
                        <ListItem onClick={() => { navigate("/services") }} className='align-itmes-end'>SERVICES</ListItem>
                        {/* <ListItem className='align-itmes-end'>BLOGS</ListItem> */}
                        <ListItem onClick={() => { navigate("/case-studies") }} className='align-itmes-end' sx={{whiteSpace:'nowrap'}}>CASE STUDIES</ListItem>
                    </List>
                </Box>
                <Box className='d-flex flex-column px-3' gap={4}>
                    <AutoRoundTextLogo />
                    <Box className='d-flex' gap={2}>
                        <Link to={'https://www.linkedin.com/company/app-gallery/'} target='_blank' className='text-white'>LN</Link>
                        <Link to={'https://www.instagram.com/appgalleryaus/'} target='_blank' className='text-white'>IN</Link>
                        <Link to={"https://www.facebook.com/appgallery.com.au"} target='_blank' className='text-white'>FB</Link>
                        <Link to={'https://twitter.com/appgalleryau'} target='_blank' className='text-white'>TW</Link>
                    </Box>
                </Box>
            </Box>
            <Typography className='text-white fs-18 mx-auto text-center pb-3'>&copy; copyright {new Date().getFullYear()} by App Gallery Pty. Ltd.</Typography>
        </Box>
    )
}

export default Footer
